import { render } from "./Grend3.vue?vue&type=template&id=0109e312&bindings={}"
import script from "./Grend3.vue?vue&type=script&lang=js"
export * from "./Grend3.vue?vue&type=script&lang=js"

import "./Grend3.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script